export function getSupportedCountries(state) {
  return state.supportedCountries || [];
}
